import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import {
  CCard,
  CCardHeader,
  CCardBody,
  CRow,
  CCardTitle,
  CTooltip,
  CImg,
  CCol,
  CSwitch,
  CFormGroup, CButton,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
// @ts-ignore
import AdsCarouselBuilder from "@glympse/ui/components/ads-carousel-form";
// @ts-ignore
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@glympse/ui/components/collapsible"
import { AdWidget, AdWidgetLocale, ImageFile } from '../../shared/models/journey';
import tooltip from '../../assets/images/tool_tip.svg';

export interface AdsCarouselFormProps {
  value: any;
  handleUpdate: (values: (AdWidget | AdWidgetLocale)[]) => void;
  handleUploadImage: (image: ImageFile) => Promise<string>;
}

const AdsCarouselForm = ({ value, handleUpdate, handleUploadImage }: AdsCarouselFormProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const formik = useFormikContext();
  const isCarouselEnabled = formik.getFieldProps('adCarouselEnabled').value;

  const handleChange = (values: any) => {
    const limitedValues = values.slice(0, 15);
    handleUpdate(limitedValues)
  }

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="tw:w-full tw:space-y-2"
    >
      <CCard className="glympser-container--roundedWithShadow">
        <CCardHeader className="glympser-roundedTop">
          <CCardTitle className="m-0">
            Ads Carousel
            <CTooltip
              placement="top"
              content="Allows to configure Ads Carousel"
            >
              <CImg src={tooltip} className="ml-2 glympser-toolTip" />
            </CTooltip>
          </CCardTitle>
        </CCardHeader>
        <CCardBody>
          <CFormGroup>
            <div className="d-flex flex-column" style={{ gap: 8 }}>
              <div className="d-flex align-items-center">
                <label htmlFor="adCarouselCheckbox" className="m-0">Enable:</label>
                <CSwitch
                  id="adCarouselCheckbox"
                  type="checkbox"
                  className="ml-1"
                  {...formik.getFieldProps({
                    name: 'adCarouselEnabled',
                    type: 'checkbox',
                  })}
                />
              </div>

              <CollapsibleTrigger asChild>
                <CButton className="d-flex align-items-center justify-content-center" variant="ghost">
                  <CIcon className="mr-2" name={isOpen ? 'cil-chevron-top' : 'cil-chevron-bottom'}/>
                  {isOpen ? 'Hide configuration' : 'Show configuration'}
                </CButton>
              </CollapsibleTrigger>
            </div>
          </CFormGroup>
          <CollapsibleContent className="space-y-2">
            {isCarouselEnabled && (
              <div className="ads-carousel-info-note">
                <p>
                  <strong>Note:</strong> Recommended image specs: 1080×1080 px JPG/PNG, ≤ 30 MB each. Carousel supports up to 15 ads.
                </p>
              </div>
            )}
            <CRow>
              <CCol>
                <AdsCarouselBuilder
                  withText
                  withImage
                  imageAsFile
                  values={value}
                  disableSaveButton
                  handleSubmit={handleChange}
                  handleUploadImage={handleUploadImage}
                />
              </CCol>
            </CRow>
          </CollapsibleContent>
        </CCardBody>
      </CCard>
    </Collapsible>
  );
};

export default AdsCarouselForm;
